import { useProfile } from '~/lib/profile-context';
import { getAvatarUrl } from '~/lib/avatar';

export const useProfileAvatarUrl = (): string | null => {
  const { profile, profilePictureUrl } = useProfile();
  
  if (profilePictureUrl) {
    return profilePictureUrl;
  }
  
  if (profile) {
    return getAvatarUrl(profile.firstName, profile.lastName);
  }
  
  return null;
};
